import React from 'react';
import './App.css';
import Main from './main/Main';
import Skills from './components/skills/Skills';
import AboutMe from './components/aboutMe/AboutMe';
import Works from './components/works/Works'
import Contacts from './components/contacts/contacts';

import {
  HashRouter as Router,
  Route,
  Switch
} from "react-router-dom";

function App() {
  return (
    <Router>
       <Switch>
        <Route exact path={"/"} component={Main}/>
        <Route  path={"/skills"} component={Skills}/>
        <Route  path={"/about"} component={AboutMe}/>
        <Route  path={"/works"} component={Works}/>
        <Route  path={"/contacts"} component={Contacts}/>
     </Switch>
    </Router>
  );
}

export default App;
